import "./App.css";
import MainRoute from "./router";
import "./assets/style/all.scss";

function App() {
  return (
    <>
      <MainRoute />
    </>
  );
}

export default App;
